import React, { useEffect, useState } from 'react';

import { Button, Select } from '~components';
import Icon, { faPlay } from '~components/icon';

interface ComponentProps {
  selectedIds: string[];
  onAction: (action: string) => void | Promise<void>;
}

const actionOptions = [
  { value: 'generate-separate', label: 'Generate PDFs' },
  { value: 'generate-combined', label: 'Generate Combined PDF' },
  { value: 'email-separate', label: 'Email Client Statements' },
];

const BulkStatementActions: React.FC<ComponentProps> = ({ selectedIds, onAction }) => {
  const [selectedAction, setSelectedAction] = useState<string | null>(null);

  const hasSelection = selectedIds.length > 0;
  const isCombinedDisabled = selectedIds.length <= 1;

  const handleGo = () => {
    if (selectedAction) {
      onAction(selectedAction);
      setSelectedAction(null);
    }
  };

  // Filter options based on selection count
  const availableOptions = actionOptions.filter((option) => {
    if (option.value === 'generate-combined' && isCombinedDisabled) {
      return false;
    }
    return true;
  });

  // Clear selectedAction if it's no longer in availableOptions
  useEffect(() => {
    if (selectedAction && !availableOptions.some((option) => option.value === selectedAction)) {
      setSelectedAction(null);
    }
  }, [selectedAction, availableOptions, isCombinedDisabled, selectedIds.length]);

  return (
    <div className="d-flex align-items-center mx-2">
      <Select
        id="statements-bulk-action-select"
        name="statements-bulk-action-select"
        className="me-2"
        size="sm"
        placeholder="Select bulk action..."
        options={availableOptions}
        value={selectedAction || undefined}
        onChange={(_, value) => setSelectedAction(value)}
        disabled={!hasSelection}
      />
      <Button
        id="statements-bulk-action-go-button"
        size="sm"
        disabled={!hasSelection || !selectedAction}
        onClick={handleGo}
      >
        <Icon className="me-2" icon={faPlay} />
        Go
      </Button>
    </div>
  );
};

export default BulkStatementActions;
